import { useCallback, useEffect, useMemo, useState } from 'react'

const BRAND_POSITION = {
  left_top: 'top-left',
  center_top: 'top-middle',
  right_top: 'top-right',
  left_bottom: 'bottom-left',
  center_bottom: 'bottom-middle',
  right_bottom: 'bottom-right',
}

const usePaymentSidebar = (isVideo, { actions, common, videos }) => {
  // Setup
  const { searchParams: query } = common

  // State
  const [isChecked, setCheckState] = useState(false)

  // Data
  const { brand_position } = query?.video_format || {}

  // Effects
  useEffect(() => {
    if (isVideo) {
      actions.videos.getVideo(query?.project_slug).catch(e => {})
    }
  }, [actions, isVideo, query])

  // Memo
  const isBranded = useMemo(
    () => brand_position !== 'without_brand',
    [brand_position]
  )

  const project = useMemo(
    () => isVideo && videos.byID.getValue(query?.project_slug).payload,
    [isVideo, query, videos]
  )

  // Handlers
  const handleAgreeChange = useCallback(
    () => setCheckState(!isChecked),
    [isChecked]
  )

  return {
    brandPosition: brand_position,
    handleAgreeChange,
    isBranded,
    isChecked,
    project,
  }
}

export { BRAND_POSITION, usePaymentSidebar }
